import * as React from 'react';
import { useState } from 'react';
import {
  Header,
  Stats,
  InventoryItems,
} from './components';
import { CreateInventoryModal } from './components/CreateInventoryModal';
import FilterInventoriesModal from './components/FilterInventoriesModal';
import { useInventoryScreen } from './useInventoryScreen';
import NoResultsIcon from '../../components/Icons/NoResultsIcon';

const Inventory = () =>
{
  const {inventories, loading, error, stats, posId, filters, setFilters, refreshInventories} = useInventoryScreen();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const handleInventoryCreated = () =>
  {
    refreshInventories();
    setIsCreateModalOpen(false);
  };

  const handleApplyFilters = (newFilters) =>
  {
    setFilters(newFilters);
  };

  const hasActiveFilters = !!(
    filters.freeText ||
    filters.status ||
    filters.type ||
    filters.dateFrom ||
    filters.dateTo
  );

  return (
    <>
      <div className="min-h-screen flex flex-col">
        <Header
          inventoriesCount={stats.total}
          onCreatePress={() => setIsCreateModalOpen(true)}
          onFilterPress={() => setIsFilterModalOpen(true)}
          hasActiveFilters={hasActiveFilters}
        />

        <Stats
          total={stats.total}
          completed={stats.completed}
          active={stats.active}
        />
        {posId === '' ?
          <div className="noResultsWrapper inventory-items-container">
              <NoResultsIcon />
              <div className="errorSubtext">Select a store to see</div>
              <div className="errorSubtext">the inventories</div>
          </div>
          :
          <InventoryItems
            inventories={inventories}
            loading={loading}
            error={error}
            posId={posId}
            onInventoryDeleted={refreshInventories}
            hasActiveFilters={hasActiveFilters}
          />
        }
      </div>

      <CreateInventoryModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        posId={posId}
        onInventoryCreated={handleInventoryCreated}
      />

      <FilterInventoriesModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onApply={handleApplyFilters}
        initialFilters={filters}
      />
    </>
  );
};

export default Inventory;
